import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { DropdownMenu, ModalButton } from "./components";
import Backend from "./utils/Backend";
import { DepositMethods, DevType, UserBalances, UserWallets } from "./typings";
import toast, { Toaster } from "react-hot-toast";
import "./tailwind.css";
import EventManager from "./utils/EventManager";

type AppArgs = {
  backend: Backend;
  publicKey: string;
  type: DevType;
  userId: string;
  events: EventManager;
};
export default ({ backend, publicKey, type, userId, events }: AppArgs) => {
  const [depositMethods, setDepositMethods] = useState<DepositMethods>([]);
  const [userBalances, setUserBalances] = useState<UserBalances>([]);
  const [fetchUserDataInterval, setFetchUserDataInterval] =
    useState<boolean>(false);
  const [displayInFiat, setDisplayInFiat] = useState<boolean>(false);
  const [userWallets, setUserWallets] = useState<UserWallets>([]);

  // console.log("eventsManager", events);
  function fetchUserBalance() {
    // console.log("Fetching balance");
    backend.userFetchBalances(publicKey, userId, "usd").then((balances) => {
      // console.log("user balances", balances);
      if (!balances) return;

      setUserBalances(balances.cryptoBalances);
    });
  }

  function userFetchWalletAddresses() {
    backend.userFetchWalletAddresses(publicKey, userId).then((wallets) => {
      if (!wallets) return;
      // console.log("wallets", wallets);
      setUserWallets(wallets);
    });
  }

  function fetchUserNotifications() {
    // console.log(" fetching user notifications");
    backend
      .userFetchNotifications(publicKey, userId)
      .then((notifs: { error: boolean; msg: string }[]) => {
        if (!notifs) return;
        // console.log("user notifications", notifs);

        for (const notif of notifs) {
          if (notif.error) {
            toast.error(notif.msg, { duration: 15000 });
          } else {
            toast.success(notif.msg, { duration: 15000 });
          }
        }
      });
  }

  useEffect(() => {
    backend
      .projectFetchCryptoDepositMethods(publicKey, type)
      .then((depositMethods) => {
        if (!depositMethods) return;
        setDepositMethods(depositMethods);
      });
    fetchUserBalance();
    userFetchWalletAddresses();
    fetchUserNotifications();
    if (!fetchUserDataInterval) {
      // console.log("fetchUserDataInterval", fetchUserDataInterval);
      setInterval(() => {
        fetchUserBalance();
        fetchUserNotifications();
      }, 15000);
      setFetchUserDataInterval(true);
    }
  }, []);

  return (
    <div>
      <div className="flex">
        <Toaster position="top-right" reverseOrder={false} />
        <DropdownMenu
          depositMethods={depositMethods}
          type={type}
          userBalances={userBalances}
          displayInFiat={displayInFiat}
          setDisplayInFiat={setDisplayInFiat}
        ></DropdownMenu>
        <ModalButton
          backend={backend}
          publicKey={publicKey}
          userId={userId}
          depositMethods={depositMethods}
          userBalances={userBalances}
          events={events}
          type={type}
          userWallets={userWallets}
          userFetchWalletAddresses={userFetchWalletAddresses}
        ></ModalButton>
      </div>
    </div>
  );
};
